import { StyleSheet, Text, View } from 'react-native';
import { colors, fontFamily, radii, space, type } from '~/ui/tokens';
import { SkeletonBlock } from './Skeleton';

interface LoadingStateProps {
  label: string;
}

export function LoadingState({ label }: LoadingStateProps) {
  return (
    <View style={styles.container}>
      <View style={styles.preview}>
        <SkeletonBlock style={styles.hero} />
        <SkeletonBlock style={styles.title} />
        <SkeletonBlock style={styles.line} />
      </View>
      <Text style={styles.label}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: space.sectionMajor,
    gap: space.compact,
  },
  preview: {
    width: '100%',
    maxWidth: 620,
    gap: space.related,
    padding: space.internal,
    borderWidth: 1,
    borderColor: colors.lineSoft,
    borderRadius: radii.md,
    backgroundColor: colors.card,
  },
  hero: { width: '100%', height: 110 },
  title: { width: '58%', height: 22 },
  line: { width: '82%', height: 12 },
  label: {
    fontFamily: fontFamily.regular,
    ...type.bodyRegular,
    color: colors.inkFaint,
  },
});
